export default __webpack_public_path__ + "static/media/gng-visivo-acustico-step1.b0ec4f79.svg";